
import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { Plus, Minus, TrendingUp, TrendingDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import BaseWidget from './BaseWidget';
import { CreditActivity } from '@/types/dashboard';

interface CreditTrackerWidgetProps {
  id: string;
  index: number;
  creditsRedeemed: number;
  isCollapsed?: boolean;
  onToggleCollapse?: () => void;
}

const CreditTrackerWidget = ({ 
  id, 
  index, 
  creditsRedeemed, 
  isCollapsed, 
  onToggleCollapse 
}: CreditTrackerWidgetProps) => {
  const [creditActivities, setCreditActivities] = useState<CreditActivity[]>([]);

  useEffect(() => {
    // Mock credit activities - replace with real data
    const mockActivities: CreditActivity[] = [
      {
        id: '1',
        type: 'bonus',
        amount: 100,
        description: 'Birthday bonus auto-applied',
        timestamp: '30 min ago'
      },
      {
        id: '2',
        type: 'spent',
        amount: 175,
        description: 'Amy redeemed for HydraFacial',
        timestamp: '1 hour ago'
      },
      {
        id: '3',
        type: 'earned',
        amount: 250,
        description: 'Sarah referred a friend',
        timestamp: '2 hours ago'
      }
    ];

    setCreditActivities(mockActivities);
  }, []);

  return (
    <BaseWidget
      id={id}
      title="💳 JUV Credit Tracker"
      index={index}
      isCollapsed={isCollapsed}
      onToggleCollapse={onToggleCollapse}
    >
      <div className="space-y-4">
        <div className="text-center">
          <div className="text-2xl font-bold text-juv-deep-chestnut">
            {creditsRedeemed.toLocaleString()} JUV Credits
          </div>
          <p className="text-sm text-gray-600">Redeemed Today</p>
        </div>

        <div className="space-y-2">
          {creditActivities.map((activity) => (
            <div key={activity.id} className="flex items-center justify-between p-2 bg-gray-50 rounded">
              <div className="flex items-center space-x-2">
                {activity.type === 'spent' ? (
                  <TrendingDown className="h-4 w-4 text-red-500" />
                ) : (
                  <TrendingUp className="h-4 w-4 text-green-500" />
                )}
                <div>
                  <p className="text-sm font-medium">
                    {activity.type === 'spent' ? '-' : '+'}{activity.amount} credits
                  </p>
                  <p className="text-xs text-gray-600">{activity.description}</p>
                </div>
              </div>
              <span className="text-xs text-gray-500">{activity.timestamp}</span>
            </div>
          ))}
        </div>

        <Button asChild variant="outline" className="w-full">
          <Link to="/staff/credits" className="flex items-center">
            <Plus className="h-4 w-4 mr-2" />
            Adjust Credits
          </Link>
        </Button>
      </div>
    </BaseWidget>
  );
};

export default CreditTrackerWidget;
